export const API_ROOT =
  process.env.REACT_APP_API_ROOT || window.location.origin + "/api";
export const ESTABLECIMIENTOS_ENDPOINT = `${API_ROOT}/establecimientos`;
export const TRAMITES_ENDPOINT = `${API_ROOT}/tramites`;
const DICCIONARIO_ENDPOINT = `${API_ROOT}/diccionario`;
export const ESTADOS_TRAMITE_ENDPOINT = `${DICCIONARIO_ENDPOINT}/estados/tramite`;
export const TIPOS_TRAMITE_ENDPOINT = `${DICCIONARIO_ENDPOINT}/tipos/tramite`;
const GIS_ENDPOINT = `${API_ROOT}/sig`;
export const PROVINCIAS_ENDPOINT = `${GIS_ENDPOINT}/provincias`;
export const DEPARTAMENTOS_ENDPOINT = `${GIS_ENDPOINT}/departamentos`;
export const LOCALIDADES_ENDPOINT = `${GIS_ENDPOINT}/localidades`;
export const ZONIFICACIONES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/zonificaciones`;
export const TECNOLOGIAS_TRATAMIENTO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/tecnologias/tratamiento`;
export const FRECUENCIAS_MONITOREO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/frecuencias/monitoreo`;
export const FRECUENCIAS_RETIRO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/frecuencias/retiro`;
export const ACTIVIDADES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/actividades`;
export const CATEOGRIAS_AMBIENTALES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/categorias`;
export const UNIDADES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/unidades`;
export const PROVEEDORES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/proveedores`;
export const SUBCUENCAS_ENDPOINT = `${DICCIONARIO_ENDPOINT}/subcuencas`;
export const DESTINOS_RESIDUOS_TRATAMIENTOS_ENDPOINT = `${DICCIONARIO_ENDPOINT}/destinos/residuos/tratamiento`;
export const DESTINOS_VERTIDO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/destinos/vertido`;
export const DESTINOS_RESIDUOS_SOLIDOS_URBANOS_ENDPOINT = `${DICCIONARIO_ENDPOINT}/destinos/residuos/urbanos`;
export const PERIODICIDADES_VUELCO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/periodicidades/vuelco`;
export const MATERIALES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/materiales`;
export const CORRIENTES_RESIDUALES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/corrientes`;
export const PELIGROSIDADES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/peligrosidades`;
export const CLASES_TANQUE_ENDPOINT = `${DICCIONARIO_ENDPOINT}/tipos/tanque`;
export const CERCOS_PERIMETRALES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/cercos`;
export const CONTAMINANTES_ENDPOINT = `${DICCIONARIO_ENDPOINT}/contaminantes`;
export const TIPOS_MUESTREO_ENDPOINT = `${DICCIONARIO_ENDPOINT}/tipos/muestreo`;
export const ARCHIVOS_ENDPOINT = `${API_ROOT}/archivos`;

export function config_request(method, body, mode) {
  return {
    method,
    headers: {
      Accept: "application/json",
      ContentType: "application/json",
    },
    ...((!!body && { body }) || {}),
    ...((!!mode && { mode }) || {}),
  };
}

function createURL(url, consulta) {
  const localURL = new URL(url);
  if (!!consulta) {
    Object.keys(consulta).forEach((param) => {
      if (consulta[param] instanceof Array) {
        consulta[param].forEach((value) => {
          localURL.searchParams.append(param, value);
        });
      } else {
        localURL.searchParams.append(param, consulta[param]);
      }
    });
  }
  return localURL;
}

async function processRequest(url, config) {
  try {
    const response = await fetch(url.href, config);
    if (response.ok) {
      if (response.status !== 204) {
        const message = await response.json();
        return Promise.resolve(message);
      } else {
        return Promise.resolve(undefined);
      }
    } else {
      const error = await response.json();
      return Promise.reject(error);
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function doGet(url, params, config, token) {
  const localConfig = {
    method: "GET",
    headers: { Accept: "application/json" },
    cache: "default",
    ...((!!config && config) || {}),
  };
  if (token) {
    localConfig["headers"] = {
      ...localConfig["headers"],
      Authorization: `Bearer ${token}`,
    };
  }
  const localURL = createURL(url, params);
  return await processRequest(localURL, localConfig);
}

export async function doPut(url, data, params, config, token) {
  const localConfig = {
    method: "PUT",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    cache: "default",
    ...((!!config && config) || {}),
    ...((!!data && { body: JSON.stringify(data) }) || {}),
  };
  if (token) {
    localConfig["headers"] = {
      ...localConfig["headers"],
      Authorization: `Bearer ${token}`,
    };
  }
  const localURL = createURL(url, params);
  return await processRequest(localURL, localConfig);
}

export async function doPost(url, data, params, config, token) {
  const localConfig = {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    cache: "default",
    ...((!!config && config) || {}),
    ...((!!data && { body: JSON.stringify(data) }) || {}),
  };
  if (token) {
    localConfig["headers"] = {
      ...localConfig["headers"],
      Authorization: `Bearer ${token}`,
    };
  }
  const localURL = createURL(url, params);
  return await processRequest(localURL, localConfig);
}

export async function doDelete(url, params, config, token) {
  const localConfig = {
    method: "DELETE",
    headers: { Accept: "application/json" },
    cache: "default",
    ...((!!config && config) || {}),
  };
  if (token) {
    localConfig["headers"] = {
      ...localConfig["headers"],
      Authorization: `Bearer ${token}`,
    };
  }
  const localURL = createURL(url, params);
  return await processRequest(localURL, localConfig);
}
